import { Tooltip } from 'bootstrap'

function labelFromAvatarEl(avatarEl) {
  const direct =
    avatarEl.getAttribute('data-bs-title') ||
    avatarEl.getAttribute('data-bs-original-title') ||
    avatarEl.getAttribute('title') ||
    avatarEl.getAttribute('aria-label')
  if (direct) return direct

  const img = avatarEl.querySelector('img')
  if (!img) return ''
  return img.getAttribute('data-bs-title') || img.getAttribute('title') || img.getAttribute('alt') || ''
}

function normalizeLabel(label) {
  const s = String(label || '').trim()
  if (!s) return ''
  if (s === '...') return ''
  return s
}

export function initTooltips(root = document) {
  const tooltipTriggers = Array.from(root.querySelectorAll('[data-bs-toggle="tooltip"]'))
  tooltipTriggers.forEach((el) => {
    Tooltip.getInstance(el)?.dispose()
    Tooltip.getOrCreateInstance(el, { container: 'body' })
  })

  const avatarEls = Array.from(root.querySelectorAll('.avatar'))
  avatarEls.forEach((avatarEl) => {
    if (avatarEl.closest('[data-no-tooltip="true"]')) return
    if (avatarEl.getAttribute('data-bs-toggle') === 'tooltip') return
    if (avatarEl.querySelector('[data-bs-toggle="tooltip"]')) return

    const label = normalizeLabel(labelFromAvatarEl(avatarEl))
    if (!label) return

    avatarEl.querySelector('img[title]')?.removeAttribute('title')
    avatarEl.removeAttribute('title')

    avatarEl.setAttribute('data-bs-toggle', 'tooltip')
    avatarEl.setAttribute('data-bs-title', label)
    if (!avatarEl.getAttribute('data-bs-placement')) avatarEl.setAttribute('data-bs-placement', 'top')

    Tooltip.getInstance(avatarEl)?.dispose()
    Tooltip.getOrCreateInstance(avatarEl, { container: 'body' })
  })
}
